import * as actions from './redux/actions';
import * as commonActions from '../../common/redux/actions';
import * as homeActions from '../../home/redux/actions';

import React, { useEffect, useState } from 'react';

import CommonService from '../../../services/commonService';
import EditProfile from './EditProfile/EditProfile';
import HomeBanner from './HomeBanner/HomeBanner';
import MainTabContainer from './MainTabContainer/MainTabContainer';
import MyAccountMainCardArea from './MyAccountMainCardArea/MyAccountMainCardArea';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import getIcons from '../functions/getIcons/getIcons';

function DefaultPage(props) {
  const [menuType, setMenuType] = useState('LEFT_MENU');
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [extraSections, setExtraSections] = useState([
    {
      icon: getIcons('wallet', props.home.operator),
      iconActive: getIcons('wallet', props.home.operator),
      name: 'RECHARGE_WALLET',
      active: false,
    },
    {
      icon: getIcons('transaction', props.home.operator),
      iconActive: getIcons('transaction', props.home.operator),
      name: 'SHARE_BALANCE',
      active: false,
    },
    // {
    //   icon: '/static/images/Pullman-Ticket-Buy-MyAccount.png',
    //   iconActive: '/static/images/Pullman-Ticket-Buy-MyAccount.png',
    //   name: 'BUY_YOUR_TICKET',
    //   active: false,
    //   backgroundColor: '#014db9',
    //   textColor: '#fff',
    // },
  ]);

  let isLoggedIn = CommonService.getLocal('loginData');
  if (!isLoggedIn || !isLoggedIn.auth_token) {
    props.history.push('/');
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onProfileEdit = () => {
    // this.setState({ showEditProfile: true });
    setShowEditProfile(true);
  };

  const onProfileEditChange = value => {
    // this.setState({ editProfile: value });
    setShowEditProfile(value);
    console.log(this.state);
  };

  const onParentMenusChange = menu => {
    if (menu === 'TOP_MENU') {
      // this.setState({ menuType: 'TOP_MENU' });
      setMenuType('TOP_MENU');
    }

    if (menu === 'LEFT_MENU') {
      makeAllTopIconInactive();
      // this.setState({ menuType: 'LEFT_MENU' });
      setMenuType('LEFT_MENU');
    }
  };

  const onTopIconChange = i => {
    onParentMenusChange('TOP_MENU');
    let extraSectionsTemp = CommonService.copyObject(extraSections);

    let j = 0;

    for (let item of extraSectionsTemp) {
      item.active = false;
    }
    extraSectionsTemp[i].active = true;

    // extraSections[i].active = true;
    // this.setState({ extraSections: extraSections });
    setExtraSections(extraSectionsTemp);
  };

  const makeAllTopIconInactive = () => {
    let extraSectionsTemp = CommonService.copyObject(extraSections);

    let j = 0;

    for (let item of extraSectionsTemp) {
      item.active = false;
    }
    // extraSections[i].active = true;
    // this.setState({ extraSections: extraSections });
    setExtraSections(extraSectionsTemp);
  };

  const { t } = props;
  // console.log('My trips in Deafult page -khjgscdvjhklsjvbc-----------', this.props);
  return CommonService.isLoggedIn() ? (
    <div className="my-account-default-page load-transition">
      <HomeBanner />

      <MyAccountMainCardArea
        profileData={props.common.loginData}
        menuType={menuType}
        onParentMenusChange={onParentMenusChange}
        onProfileEdit={onProfileEdit}
        actions={props.actions}
        data={props.myAccount}
        onSelectionChange={onTopIconChange}
        t={t}
        extraSections={extraSections}
        history={props.history}
        operator={props.home.operator}
      />

      <MainTabContainer
        menuType={menuType}
        onParentMenusChange={onParentMenusChange}
        actions={props.actions}
        data={{ ...props.myAccount, ...props.common, ...props.home }}
        t={t}
        params={props.match.params}
        history={props.history}
        onTopIconChange={onTopIconChange}
        metaData={props.home.metaData}
        operator={props.home.operator}
      />

      <EditProfile
        showEditProfile={showEditProfile}
        onHide={() => setShowEditProfile(false)}
        profileData={props.common.loginData}
        updateProfile={props.actions.updateProfile}
        setLoginData={props.actions.setLoginData}
        showLoader={props.common.updateProfilePending}
        operator={props.home.operator}
        t={t}
        closeModal={() => setShowEditProfile(false)}
      />
    </div>
  ) : (
    <div className="my-account-default-page"></div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    myAccount: state.myAccount,
    common: state.common,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions, ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));

// export class DefaultPage extends Component {
//   static propTypes = {
//     myAccount: PropTypes.object.isRequired,
//     common: PropTypes.object,
//     actions: PropTypes.object.isRequired,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {
//       menuType: 'LEFT_MENU',
//       showEditProfile: false,
//       extraSections: [
//         {
//           icon: '/static/images/icon_kupos_wallet-grey.png',
//           iconActive: '/static/images/icon_kupos_wallet.png',
//           name: 'RECHARGE_WALLET',
//           active: false,
//         },
//         {
//           icon: '/static/images/icon_mobile_transactions-grey.png',
//           iconActive: '/static/images/icon_mobile_transactions.png',
//           name: 'SHARE_BALANCE',
//           active: false,
//         },
//         {
//           icon: '/static/images/icon_kupos_premium-grey.png',
//           iconActive: '/static/images/icon_kupos_premium.png',
//           name: 'KUPOS_PREMIUM',
//           active: false,
//         },
//       ],
//     };
//     let isLoggedIn = CommonService.getLocal('loginData');
//     if (!isLoggedIn || !isLoggedIn.auth_token) {
//       this.props.history.push('/');
//     }
//   }
//   componentWillMount() {
//     window.scrollTo(0, 0);
//   }

//   onProfileEdit = () => {
//     this.setState({ showEditProfile: true });
//   };

//   onProfileEditChange = value => {
//     this.setState({ editProfile: value });
//     console.log(this.state);
//   };

//   // when the different menu is selected/switched
//   onParentMenusChange = menu => {
//     if (menu === 'TOP_MENU') {
//       this.setState({ menuType: 'TOP_MENU' });
//     }

//     if (menu === 'LEFT_MENU') {
//       this.makeAllTopIconInactive();
//       this.setState({ menuType: 'LEFT_MENU' });
//     }
//   };

//   onTopIconChange = i => {
//     this.onParentMenusChange('TOP_MENU');
//     let extraSections = CommonService.copyObject(this.state.extraSections);

//     let j = 0;

//     for (let item of extraSections) {
//       item.active = false;
//     }
//     extraSections[i].active = true;

//     // extraSections[i].active = true;
//     this.setState({ extraSections: extraSections });
//   };

//   makeAllTopIconInactive = () => {
//     let extraSections = CommonService.copyObject(this.state.extraSections);

//     let j = 0;

//     for (let item of extraSections) {
//       item.active = false;
//     }
//     // extraSections[i].active = true;
//     this.setState({ extraSections: extraSections });
//   };

//   render() {
//     const { t } = this.props;
//     // console.log('My trips in Deafult page -khjgscdvjhklsjvbc-----------', this.props);
//     return CommonService.isLoggedIn() ? (
//       <div className="my-account-default-page load-transition">
//         <HomeBanner />

//         <MyAccountMainCardArea
//           profileData={this.props.common.loginData}
//           menuType={this.state}
//           onParentMenusChange={this.onParentMenusChange}
//           onProfileEdit={this.onProfileEdit}
//           actions={this.props.actions}
//           data={this.props.myAccount}
//           onSelectionChange={this.onTopIconChange}
//           t={t}
//           extraSections={this.state.extraSections}
//           history={this.props.history}
//         />

//         <MainTabContainer
//           menuType={this.state}
//           onParentMenusChange={this.onParentMenusChange}
//           actions={this.props.actions}
//           data={{ ...this.props.myAccount, ...this.props.common, ...this.props.home }}
//           t={t}
//           params={this.props.match.params}
//           history={this.props.history}
//           onTopIconChange={this.onTopIconChange}
//           metaData={this.props.home.metaData}
//         />

//         <EditProfile
//           showEditProfile={this.state.showEditProfile}
//           onHide={() => this.setState({ showEditProfile: false })}
//           profileData={this.props.common.loginData}
//           updateProfile={this.props.actions.updateProfile}
//           setLoginData={this.props.actions.setLoginData}
//           showLoader={this.props.common.updateProfilePending}
//           t={t}
//           closeModal={() => this.setState({ showEditProfile: false })}
//         />
//       </div>
//     ) : (
//       <div className="my-account-default-page"></div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/themes/my-account/DefaultPage.js